<template>
  <div class="main">
    <div class="mnhead">
      <div class="headdetailed" v-for="(item,index) in memCardInfo" :key="index">
        <div class="rowone">
          <img
            src="../../../resource/img/WeChatbfaed0e8af0e4c8e8548f1f00bfb909e.png"
            class="mnlogo"
          />
          <div class="mntext">
            <p
              v-if="item.storeInfo.storeName==null"
              style="font-size:16px;font-weight:400;font-family:PingFangSC-Regular;color:black;"
            >深圳链美科技</p>
            <p
              v-else
              style="font-size:16px;font-weight:400;font-family:PingFangSC-Regular;color:black;"
            >{{item.storeInfo.storeName}}</p>
            <p>免单内容：{{item.storeInfo.freeContent}}</p>
            <p>截止日期：{{item.activity.endDate}}</p>
          </div>
          <img src="../../../resource/img/qqq.png" class="saoma" @click="scanewm" />
        </div>
        <div class="rowtwo">
          <div style="width:10%;height:80%;float:left;text-align: center;margin-left:5vh;">
            <img src="../../../resource/img/fafang.png" style="width:80%;height:40%;" />
            <p style="width:100%;height:18%;">总数量</p>
            <p style="width:100%;height:10%;">{{item.cardSum}}张</p>
          </div>
          <div style="width:12%;height:80%;float:left;text-align: center;margin-left:8vh;">
            <img
              src="../../../resource/img/duihao.png"
              style="width:65%;height:40%;"
              @click="Used(index)"
            />
            <p style="width:100%;height:18%;">已使用</p>
            <p style="width:100%;height:10%;">{{item.unUsedCount}}张</p>
          </div>
          <div style="width:14%;height:80%;float:left;text-align: center;margin-left:5vh;">
            <img
              src="../../../resource/img/aaa.png"
              style="width:65%;height:40%;"
              @click="Inuse(index)"
            />
            <p style="width:100%;height:18%;">正在使用</p>
            <p style="width:100%;height:10%;">{{item.usedCount}}张</p>
          </div>
          <div style="width:10%;height:80%;float:left;text-align: center;margin-left:7vh;">
            <img
              src="../../../resource/img/weikaishi.png"
              style="width:80%;height:40%;"
              @click="Notused(index)"
            />
            <p style="width:100%;height:18%;">未使用</p>
            <p style="width:100%;height:10%;">{{item.useingCount}}张</p>
          </div>
        </div>
      </div>
    </div>
    <div class="mnbody">
      <div class="Aroundactivity">
        <div class="zbhd">
          <font style="padding-left:5%;padding-top:10%">周边活动</font>
        </div>
        <div class="hdnr">
          <div class="nr">
            <img
              src="../../../resource/img/WeChatbfaed0e8af0e4c8e8548f1f00bfb909e.png"
              class="mnlogo"
            />
            <div class="nrtext">
              <p
                style="font-size:16px;font-weight:400;font-family:PingFangSC-Regular;color:black;"
              >深圳市握奇科技</p>
              <p>免单内容：大保健项目满200减99元</p>
              <button class="cjbtn">立即参与</button>
            </div>
          </div>
        </div>
        <div class="hdnr">
          <div class="nr">
            <img
              src="../../../resource/img/WeChatbfaed0e8af0e4c8e8548f1f00bfb909e.png"
              class="mnlogo"
            />
            <div class="nrtext">
              <p
                style="font-size:16px;font-weight:400;font-family:PingFangSC-Regular;color:black;"
              >深圳市握奇科技</p>
              <p>免单内容：大保健项目满200减99元</p>
              <button class="cjbtn">立即参与</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import wx from "weixin-js-sdk";
// wx.ready(function() {
//       console.log("ready");});
export default {
  name: "MerUnionmbmainpage",
  data() {
    return {
      urlParam: {},
      isCollapse: false,
      memCardInfo: [],
      atvCardInfo: [],
      imageUrl: "http://m.mbspt.com"
    };
  },
  created() {
    this.urlParam = this.$route.params;
    this.MemCardInfo();
    // //this.scanewm();
    // this.AtvCardInfo();
    this.$axios
      .post(
        "/mer/findShareConfig.do",
        this.$qs.stringify({
          merId: 19,
          // merId: this.memCardInfo[index].storeInfo.merId,
          url: encodeURIComponent(window.location.href.split("#")[0])
        })
      )
      .then(response => {
        console.log(response.data.map.appId),
          wx.config({
            appId: response.data.map.appId, //APPID
            timestamp: response.data.map.timestamp, //上面main方法中拿到的时间戳timestamp
            nonceStr: response.data.map.nonceStr, //上面main方法中拿到的随机数nonceStr
            signature: response.data.map.signature, //上面main方法中拿到的签名signature
            //需要调用的方法接口
            jsApiList: ["scanQRCode"]
          });
      })
      .catch(function(error) {
        console.log(error);
      });
    wx.ready(function() {
      console.log("ready");
    });
    // wx.ready(function() {
    //   console.log("ready");
    //   // config信息验证成功后会执行ready方法,所有接口调用都必须在config接口获得结果之后
    //   // config 是一个客户端的异步操作,所以如果需要在页面加载时调用相关接口,则须把相关接口放在ready函数中调用来确保正确执行.对于用户触发是才调用的接口,则可以直接调用,不需要放在ready函数中
    //   // wx.checkJsApi({
    //   //   // 判断当前客户端版本是否支持指定JS接口
    //   //   jsApiList: ["scanQRCode"],
    //   //   success: function(res) {
    //   //     // 以键值对的形式返回，可用true，不可用false。如：{"checkResult":{"scanQRCode":true},"errMsg":"checkJsApi:ok"}
    //   //     if (res.checkResult.scanQRCode === true) {
    //   //       wx.scanQRCode({
    //   //         // 微信扫一扫接口
    //   //         desc: "scanQRCode desc",
    //   //         needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
    //   //         scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维码，默认二者都有
    //   //         success: function(res) {
    //   //           const getCode = res.resultStr; // 当needResult 为 1 时，扫码返回的结果
    //   //         }
    //   //       });
    //   //     } else {
    //   //       alert("抱歉，当前版本不支持扫一扫");
    //   //     }
    //   //   },
    //   //   fail: function(res) {
    //   //     // 检测getNetworkType该功能失败时处理
    //   //     alert("fail" + res);
    //   //   }

    // // });
  },
  methods: {
    MemCardInfo: function() {
      var that = this;
      that.$axios
        .post(
          "/mer/merUnion/store/findCardInfo.do",
          that.$qs.stringify({
            storeId: that.urlParam.user.storeId
          })
        )
        .then(response => {
          that.memCardInfo = response.data.list;
          console.log(that.memCardInfo);
          for (let index = 0; index < that.memCardInfo.length; index++) {
            that.memCardInfo[index].activity.endDate = that.memCardInfo[
              index
            ].activity.endDate.split(" ")[0];
          }
        })
        .catch(function(error) {
          //请求失败处理
          console.log(error);
        });
    },
    Used: function(index) {
      var that = this;
      console.log(that.memCardInfo[index].activity.activityId);
      that.$router.push({
        path: "/MerUnionmbViewAlliance",
        name: "MerUnionmbViewAlliance",
        params: {
          activityId: that.memCardInfo[index].activity.activityId,
          status: 2,
          storeId: that.urlParam.user.storeId
        }
      });
    },
    Inuse: function(index) {
      var that = this;
      console.log(that.memCardInfo[index].activity.activityId);
      that.$router.push({
        path: "/MerUnionmbViewAlliance",
        name: "MerUnionmbViewAlliance",
        params: {
          activityId: that.memCardInfo[index].activity.activityId,
          status: 1,
          storeId: that.urlParam.user.storeId
        }
      });
    },
    Notused: function(index) {
      var that = this;
      console.log(that.memCardInfo[index].activity.activityId);
      that.$router.push({
        path: "/MerUnionmbViewAlliance",
        name: "MerUnionmbViewAlliance",
        params: {
          activityId: that.memCardInfo[index].activity.activityId,
          status: 0,
          storeId: that.urlParam.user.storeId
        }
      });
    },
    scanewm: function() {
      console.log("ok")
      wx.scanQRCode({
        // 微信扫一扫接口
        desc: "scanQRCode desc",
        needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维码，默认二者都有
        success: function(res) {
          const getCode = res.resultStr;
          console.log(res);
          // 当needResult 为 1 时，扫码返回的结果
        }
      });

      //   console.log(this.memCardInfo[index].storeInfo.merId);
      //   this.$axios
      //     .post(
      //       "/mer/findShareConfig.do",
      //       this.$qs.stringify({
      //         merId: 19,
      //         // merId: this.memCardInfo[index].storeInfo.merId,
      //         url: encodeURIComponent(window.location.href.split("#")[0])
      //       })
      //     )
      //     .then(response => {})
      //     .catch(function(error) {
      //       console.log(error);
      //     });
    },
    AtvCardInfo: function() {
      var that = this;
      that.$axios
        .post("", that.$qs.stringify({}))
        .then(response => {})
        .catch(function(error) {
          //请求失败处理
          console.log(error);
        });
    }
  }
};
</script>

<style scoped>
.main {
  margin-top: 50px;
  width: 100%;
  height: 100%;
}
.mnhead {
  width: 100%;
  height: auto;
  background-image: url("../../../resource/img/Nipic_12106414_20160922174257880038.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  -moz-background-size: 100% 100%;
  text-align: center;
  display: flex;
  flex-direction: column;
}
.headdetailed {
  width: 90%;
  height: 30vh;
  background: rgba(255, 255, 255, 1);
  border-radius: 20px;
  margin-top: 6vh;
  margin-bottom: 2vh;
  margin-left: 5%;
}
.rowone {
  width: 100%;
  height: 50%;
  text-align: left;
  padding-top: 3%;
  color: grey;
}
.mnlogo {
  width: 26%;
  height: 90%;
  padding-left: 4%;
  float: left;
}
.mntext {
  width: 50%;
  height: 90%;
  padding-left: 4%;
  float: left;
  padding-top: 0;
}
.nrtext {
  width: 65%;
  height: 90%;
  padding-left: 2%;
  padding-top: 3%;
  float: left;
}
.rowtwo {
  width: 100%;
  height: 50%;
}
.saoma {
  width: 6%;
  height: 3vh;
  float: left;
}
.Aroundactivity {
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 1);
}
.zbhd {
  width: 100%;
  height: 20%;
  font-size: 0.38rem;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(0, 0, 0, 1);
  line-height: 50px;
  background: linear-gradient(
    123deg,
    rgba(253, 134, 30, 1) 0%,
    rgba(255, 0, 0, 1) 100%
  );
  /* -webkit-background-clip: text; */
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.hdnr {
  width: 100%;
  height: 100%;
  margin-top: 5%;
}
.nr {
  width: 100%;
  height: 30%;
  text-align: left;
  padding-top: 3%;
  color: grey;
}
.cjbtn {
  width: 30%;
  height: 4vh;
  background: linear-gradient(
    135deg,
    rgba(74, 58, 149, 1) 0%,
    rgba(121, 44, 139, 1) 100%
  );
  border-radius: 20px;
  font-size: 22px;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  float: right;
  color: white;
  border: none;
}
.Submission_page {
  background: rgba(0, 0, 0, 0.3);
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 5;
  display: flex;
  justify-content: center;
}
.smerm {
  width: 33vh;
  height: 33vh;
  background-color: white;
  margin-top: 60%;
  display: block;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/active/member/MerUnionmbmainpage.vue